<template>
  <div
    class="flex min-h-screen bg-slate-50 dark:bg-dark-bg font-sans selection:bg-primary selection:text-white transition-colors duration-300 text-slate-900 dark:text-white"
  >
    <Sidebar />

    <div class="flex-1 flex flex-col h-screen overflow-hidden">
      <Navbar />
      <main
        class="flex-1 overflow-y-auto custom-scrollbar relative bg-slate-50 dark:bg-dark-bg"
      >
        <!-- Background Glow - Only in dark mode -->
        <div
          class="hidden dark:block absolute top-0 right-0 w-[500px] h-[500px] bg-primary opacity-[0.03] blur-[120px] pointer-events-none"
        ></div>
        <div class="p-8 relative z-10">
          <slot></slot>
        </div>
      </main>
    </div>
  </div>
</template>

<style scoped>
/* Global Scrollbar */
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #e2e8f0; /* slate-200 */
  border-radius: 20px;
}
:deep(.dark) .custom-scrollbar::-webkit-scrollbar-thumb,
.dark .custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #1e2330;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #cbd5e1; /* slate-300 */
}
:deep(.dark) .custom-scrollbar::-webkit-scrollbar-thumb:hover,
.dark .custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #2a2f3e;
}
</style>

<script>
import Sidebar from "./Sidebar.vue";
import Navbar from "./Navbar.vue";
import Footer from "./Footer.vue";

export default {
  name: "MainLayout",
  components: { Sidebar, Navbar, Footer },
};
</script>
